export const parseVehicleAge = (vehicleAge: string): { operator: string, years: number } => {
    let operator = '';
    let years = '';
    const splitedVehicleAge = vehicleAge.split('');
    splitedVehicleAge.forEach((character: string) => {
        if (character === '<' || 
            character === '<=' || 
            character === '>' ||
            character === '>=') {
            operator += character;
        } else if (!isNaN(Number(character))) {
            years += character;
        }
    });
    return { operator, years: Number(years) };
};